import * as _ from 'lodash'
import {IDateRange, MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {ErrorMessage_restate, ValidateDateRange, WarningMessage_restate} from "../PA.Core/Basic/MessageUtils";
import {TPMEventSpend} from "./TPMEventBO.ITPMEventSpend";
import {
  ApprovalAction,
  ApprovalRangeBoundsType,
  ApprovalSubType,
  ApprovalType,
  StatusType
} from "../PA.Core/PA.Core.IF.Workflow";
import {ASync} from "../PA.Core/Basic/ASync";
import {TPMEventOffInvoiceUtils} from "./TPMEventOffInvoiceUtils";
import {ApprovalService} from "../PA.MD.Services/ApprovalService";

import {DateUtils} from "../PA.Core/Basic/Dates";
import {NumberUtils} from "../PA.Core/Basic/Numbers";
import {WB_TPM_EventSpendPrdGrpRow, WB_TPM_EventSpendPrdRow} from "../PA.Core/PAdbSchemaRows";
import {PaymentMethod_OffInvoice} from "../PA.TPM.Core/TPM.Constants";


export class TPMEventSpendValidations {

  static Validate(self: TPMEventSpend): Promise<void> {

    let bDone = false

    return new Promise<void>((resolve, error) => {

      let sId = self.TPMEventSpendRow.cif.EVENT_SPEND_ID
      if(!self.bIsLoaded){
        bDone = true
        ErrorMessage_restate(self.ValidateMessageProvider, true, `NotLoaded-${sId}`,  `Event Spend (${sId}) failed to loaded`)
        resolve()
        return
      }

      // Validate Event Spend Fields
      TPMEventSpendValidations.ValidateEventSpendFields(self)
        .then((ignore:any) => {
          // Skip further validations if Errors exist
          if (self.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
            bDone = true
            resolve()
            return
          }

          return TPMEventOffInvoiceUtils.validateOffInvoiceChanges(self)
        })
        .then((ignore:any) => {
          if(bDone) return
          // Skip further validations if Errors exist
          if(self.ValidateMessageProvider.countMessages(MessageType.Error) > 0){
            bDone = true
            resolve()
            return
          }

          return TPMEventSpendValidations.ValidateEventSpendWorkflow(self)
        })
        .then((ignore:any) => {
          if(bDone) return
          // Skip further validations if Errors exist
          if(self.ValidateMessageProvider.countMessages(MessageType.Error) > 0){
            bDone = true
            resolve()
            return
          }

          return TPMEventSpendValidations.ValidateEventSpendApprovalLimits(self)
        })
        .then((ignore:any) => {
          if(bDone) return
          // Skip further validations if Errors exist
          if(self.ValidateMessageProvider.countMessages(MessageType.Error) > 0){
            bDone = true
            resolve()
            return
          }

          // Validate Event Spend Overlap
          return TPMEventSpendValidations.ValidateEventSpendOverlap(self)
        })
        .then((ignore:any) => {
          if(bDone) return
          // Skip further validations if Errors exist
          if(self.ValidateMessageProvider.countMessages(MessageType.Error) > 0){
            bDone = true
            resolve()
            return
          }
          // Validate Next..
          // return nextValidation Function... and remove resolve().. (follow pattern)
          resolve()
        })
        .catch((err:any) => {
          error(err)
        })
    })
  }


  static ValidateBeforeDelete(aSpend: TPMEventSpend): Promise<void> {

    return new Promise<void>((resolve, error) => {


      resolve()
    })
  }


  //  Name the functions reasonably and put them in the top Validate Function.
  //



  static ValidateEventSpendFields(aSpend: TPMEventSpend): Promise<void> {

    return new Promise((resolve, error) => {

      let aBO = aSpend.TPMEventBO
      let Evt = aBO.WB_TPMEvent
      let EvtType = Evt.WB_EventTypeRow
      let PlanPeriod = Evt.WB_PlanRow.WB_PeriodRow

      let bIsOffInvoice = (aSpend.TPMEventSpendRow.cif.PAYMENT_METHOD === PaymentMethod_OffInvoice)

      let bIsEventPreApproval = aBO.PrimaryWorkflowProcessor.CurrentState.StatusTypeIsPreApproval
      let bIsEventNextStateApproved = aBO.PrimaryWorkflowProcessor.NextState.StatusTypeApproved
      let bIsEventRequestingFirstApproval = bIsEventPreApproval && bIsEventNextStateApproved

      let bIsEventSpendPreApproval = aSpend.PrimaryWorkflowProcessor.CurrentState.StatusTypeIsPreApproval
      let bIsEventSpendNextStateApproved = aSpend.PrimaryWorkflowProcessor.NextState.StatusTypeApproved
      let bIsEventSpendRequestingFirstApproval = bIsEventSpendPreApproval && bIsEventSpendNextStateApproved

      let bIsEventSpendClosedOrCancelled = aSpend.PrimaryWorkflowProcessor.CurrentState.StatusTypeClosed || aSpend.PrimaryWorkflowProcessor.CurrentState.StatusTypeClosed


      let PlanPeriodRange: IDateRange = {StartDt: PlanPeriod.PeriodStartDt, EndDt: PlanPeriod.PeriodEndDt}
      let dateValidateOptions_PlanningPeriod = { bLogError: true, validateRange: PlanPeriodRange, validationRangeName: 'Planning Period' }

      let EventInStorePeriodRange: IDateRange = {StartDt: Evt.InStoreStartDt, EndDt: Evt.InStoreEndDt}
      let dateValidateOptions_EventInStore = { bLogError: true, validateRange: EventInStorePeriodRange, validationRangeName: 'Event InStore Period' }

      let EventShipmentPeriodRange: IDateRange = {StartDt: Evt.ShipmentStartDt, EndDt: Evt.ShipmentEndDt}
      let dateValidateOptions_EventShipment = { bLogError: true, validateRange: EventShipmentPeriodRange, validationRangeName: 'Event Shipment Period' }

      let aRow = aSpend.TPMEventSpendRow
      let id_ui = aRow.cif.EVENT_SPEND_ID
      let EvtSTypeRow = aRow.WB_TPM_EventSpendTypeRow

      if (_.isEmpty(EvtSTypeRow)) {
        ErrorMessage_restate(aBO.ValidateMessageProvider, true, 'InvalidSpendType ' + aRow.cif.WB_EVTSTYPE_ID, "System Error: Invalid Spend Type: " + aRow.cif.WB_EVTSTYPE_ID)
        return false
      }

      // Validate the Tactic..
      if(aSpend.PrimaryWorkflowProcessor.NextState.StatusTypePendingApproval && aSpend.TPMEventSpendRow.cif.PLANNED_SPEND == 0) {
        WarningMessage_restate(aBO.ValidateMessageProvider, true, `InvalidPlannedSpend`,  `Event Spend (${id_ui}) must have Planned Spend > 0.`)
        aSpend.PrimaryWorkflowProcessor.setStateType(StatusType.Initial, StatusType.Initial)
      }

      if (EvtSTypeRow.cif.RATE_LEVEL == 'Header') {
        ErrorMessage_restate(aBO.ValidateMessageProvider, (aRow.cif.RATE_AMT < 0), `NegativeRate${id_ui}`, `Event Spend (${id_ui}) has negative Rate Amount.`)
      }

      if (EvtSTypeRow.bInStoreDatesShowInd && EvtSTypeRow.cif.INSTOREDATES_POLICY == 'UserInput') {
        ValidateDateRange(aBO.ValidateMessageProvider, `Spend (${id_ui}) InStore Dates`, aRow.InStoreStartDt, aRow.InStoreEndDt, dateValidateOptions_PlanningPeriod)
        ValidateDateRange(aBO.ValidateMessageProvider, `Spend (${id_ui}) InStore Dates`, aRow.InStoreStartDt, aRow.InStoreEndDt, dateValidateOptions_EventInStore)
      }

      if (EvtSTypeRow.bShipmentDatesShowInd && EvtSTypeRow.cif.SHIPMENTDATES_POLICY == 'UserInput') {
        ValidateDateRange(aBO.ValidateMessageProvider, `Spend (${id_ui}) Shipment Dates`, aRow.ShipmentStartDt, aRow.ShipmentEndDt, dateValidateOptions_PlanningPeriod)
        ValidateDateRange(aBO.ValidateMessageProvider, `Spend (${id_ui}) Shipment Dates`, aRow.ShipmentStartDt, aRow.ShipmentEndDt, dateValidateOptions_EventShipment)
      }

      if (EvtSTypeRow.bOrderDatesShowInd && EvtSTypeRow.cif.ORDERDATES_POLICY == 'UserInput') {
        ValidateDateRange(aBO.ValidateMessageProvider, `Spend (${id_ui}) Order Dates`, aRow.OrderStartDt, aRow.OrderEndDt, dateValidateOptions_PlanningPeriod)
      }

      if (EvtSTypeRow.bDistributionDatesShowInd && EvtSTypeRow.cif.DISTRIBUTIONDATES_POLICY == 'UserInput') {
        ValidateDateRange(aBO.ValidateMessageProvider, `Spend (${id_ui}) Distribution Dates`, aRow.DistributionStartDt, aRow.DistributionEndDt, dateValidateOptions_PlanningPeriod)
      }

      if (bIsOffInvoice  &&  EvtSTypeRow.cif.RATE_LEVEL === 'ProductGroup' && aSpend.TPMEventSpendRow.cif.PAID_IN_FULL_IND !== '1') {
        _.forEach(aRow.WB_TPM_EventSpendPrdGrpRows, (row) => {
          if(!(row.isActive && row.cif.INCLUDE_IND === '1')) return
          let rateAmt: any = row.cif.RATE_AMT
          if (_.toNumber(rateAmt) <= 0 ){
            if(bIsEventRequestingFirstApproval || bIsEventSpendRequestingFirstApproval){
              ErrorMessage_restate(aBO.ValidateMessageProvider, true, `ZeroRate-${row.cif.WB_TEVTS_ID}-${row.cif.WB_PRDGRP_ID}`,  `Off Invoice Tactic ${aRow.cif.EVENT_SPEND_ID} / Product Group ${row.cif.WB_ProductGroupRow.PRODUCT_GROUP_NAME}  has zero Rate.`)
            } else {
              ErrorMessage_restate(aBO.ValidateMessageProvider, true, `ZeroRate-${row.cif.WB_TEVTS_ID}-${row.cif.WB_PRDGRP_ID}`,  `Off Invoice Tactic ${aRow.cif.EVENT_SPEND_ID} / Product Group ${row.cif.WB_ProductGroupRow.PRODUCT_GROUP_NAME}  has zero Rate.`)
            }
          }
        })
      }


      resolve()
    })

  }

  static async ValidateEventSpendApprovalLimits(aSpend: TPMEventSpend): Promise<void> {

    let bIsApproved = aSpend.PrimaryWorkflowProcessor.CurrentState.StatusTypeIsPostApproval || aSpend.PrimaryWorkflowProcessor.NextState.StatusTypeIsPostApproval

    let aBO = aSpend.TPMEventBO
    let evt = aSpend.TPMEventBO.WB_TPMEvent
    let evts = aSpend.TPMEventSpendRow
    let pln = evt.WB_PlanRow
    let aWbBusinessUnitId = evt.WB_PlanRow.WB_PlanTypeRow.cif.WB_BUSINESSUNIT_ID
    let dateRange = DateUtils.RangeUnion(aSpend.TPMEventSpendRow.InStore.Range, aSpend.TPMEventSpendRow.Shipment.Range)
    let drApproval = await ApprovalService.getApprovalRule(aWbBusinessUnitId, ApprovalType.EventSpend, ApprovalSubType.SpendRate,
      {
        effectiveDateRange: dateRange,
        WB_CUST_ID: pln.cif.WB_CUST_ID_PLANNING,
        PAYMENTMETHOD: evts.cif.PAYMENT_METHOD,
        RATEBASIS: evts.cif.RATE_BASIS_ID,
        RATEUOM: evts.cif.RATE_UOM,
        WB_EVTSTYPE_ID: evts.cif.WB_EVTSTYPE_ID,
        RANGE_BOUND_TYPE: ApprovalRangeBoundsType.AbsoluteRateLimit
      })

    if (_.isEmpty(drApproval)) {
      return
    }

    function logRateMessage(aCode: string, aMsg: string){
      switch (drApproval.cif.APPROVAL_ACTION) {
        case ApprovalAction.RaiseError:
          ErrorMessage_restate(aBO.ValidateMessageProvider, true, aCode, aMsg)
          break;
        case ApprovalAction.RaiseWarning:
          WarningMessage_restate(aBO.ValidateMessageProvider, true, aCode, aMsg)
          break;
        case ApprovalAction.RaiseErrorIfApproved:
          if(bIsApproved)
            ErrorMessage_restate(aBO.ValidateMessageProvider, true, aCode, aMsg)
          break;
      }

    }


    switch(evts.WB_TPM_EventSpendTypeRow.cif.RATE_LEVEL){
      case 'Header':
        if (evts.cif.RATE_AMT > drApproval.cif.RANGE_UPPER_BOUND_AMT) {
          let msg = `Approval Error: Tactic (${evts.cif.EVENT_SPEND_ID}) has invalid Spend Rate: ${NumberUtils.formatMoney(evts.cif.RATE_AMT)}, exceeds ${NumberUtils.formatMoney(drApproval.cif.RANGE_UPPER_BOUND_AMT)}.`
          logRateMessage(`InvalidSpendRate ${evts.cif.WB_EVTSTYPE_ID}`, msg)
        }
      break;

      case 'ProductGroup':
        let evtsPGs = _.filter(evts.WB_TPM_EventSpendPrdGrpRows, (aRow) => (aRow.isActive && (aRow.cif.INCLUDE_IND === '1') && aRow.WB_ProductGroupRow ))
        _.forEach(evtsPGs, (aRow: WB_TPM_EventSpendPrdGrpRow) => {
          if (aRow.cif.RATE_AMT > drApproval.cif.RANGE_UPPER_BOUND_AMT) {
            let msg = `Approval Error: Tactic (${evts.cif.EVENT_SPEND_ID}), Product Group (${aRow.WB_ProductGroupRow.cif.PRODUCT_GROUP_NAME}) has invalid Spend Rate: ${NumberUtils.formatMoney(aRow.cif.RATE_AMT)}, exceeds ${NumberUtils.formatMoney(drApproval.cif.RANGE_UPPER_BOUND_AMT)}.`
            logRateMessage(`InvalidSpendRate ${evts.cif.WB_EVTSTYPE_ID}:${aRow.cif.WB_PRDGRP_ID}` , msg)
          }
        })
        break;

      case 'Product':
        let evtsPrds = _.filter(evts.WB_TPM_EventSpendPrdRows, (aRow) => (aRow.isActive && (aRow.cif.INCLUDE_IND === '1') && aRow.WB_ProductRow))
        _.forEach(evtsPrds, (aRow: WB_TPM_EventSpendPrdRow) => {
          if (aRow.cif.RATE_AMT > drApproval.cif.RANGE_UPPER_BOUND_AMT) {
            let msg = `Approval Error: Tactic (${evts.cif.EVENT_SPEND_ID}), Product (${aRow.WB_ProductRow.cif.PRODUCT_NAME}) has invalid Spend Rate: ${NumberUtils.formatMoney(aRow.cif.RATE_AMT)}, exceeds ${NumberUtils.formatMoney(drApproval.cif.RANGE_UPPER_BOUND_AMT)}.`
            logRateMessage(`InvalidSpendRate ${evts.cif.WB_EVTSTYPE_ID}:${aRow.cif.WB_PROD_ID}` , msg)
          }
        })
        break;
    }

  }

  static ValidateEventSpendWorkflow(aSpend: TPMEventSpend): Promise<void> {

    return new Promise((resolve, error) => {

      let aBO = aSpend.TPMEventBO
      let evt = aBO.WB_TPMEvent

      let evtCurrState = aBO.PrimaryWorkflowProcessor.CurrentState
      let evtNextState = aBO.PrimaryWorkflowProcessor.NextState
      let esCurrState = aSpend.PrimaryWorkflowProcessor.CurrentState
      let esNextState = aSpend.PrimaryWorkflowProcessor.NextState
      let wfValidatePromise: Promise<any> = undefined
      let bAddWorkflowMessages = true

      switch(true){
        case evtNextState.StatusTypeCancelled && !evtCurrState.StatusTypeCancelled:
          wfValidatePromise = aSpend.PrimaryWorkflowProcessor.ValidateTransition({UsingNextStateType: StatusType.Cancelled})
          break;

        case evtNextState.StatusTypeClosed && !evtCurrState.StatusTypeClosed:
          wfValidatePromise = aSpend.PrimaryWorkflowProcessor.ValidateTransition({UsingNextStateType: StatusType.Closed})
          break;

        case evtCurrState.StatusTypeIsPreApproval && evtNextState.StatusTypeApproved:
          wfValidatePromise = aSpend.PrimaryWorkflowProcessor.ValidateTransition({UsingNextStateType: StatusType.Approved})
          break;

        case evtCurrState.StatusTypeIsPreApproval:
          wfValidatePromise = ASync.resolve()
          bAddWorkflowMessages = false
          break;

        case evtCurrState.StatusTypeIsPostApproval:
          wfValidatePromise = aSpend.PrimaryWorkflowProcessor.ValidateTransition({})
          break;

        default:
          wfValidatePromise = ASync.resolve()
          bAddWorkflowMessages = false
          break;
      }

      wfValidatePromise
        .then((ignore) => {
          if(bAddWorkflowMessages){
            aSpend.ValidateMessageProvider.addMessages(aSpend.PrimaryWorkflowProcessor.WorkflowMessageProvider.Messages)
          }
          resolve()
        })
        .catch((err) => {
          error(err)
        })

    })

  }



  static ValidateEventSpendOverlap(aSpend: TPMEventSpend): Promise<void> {

    return new Promise((resolve, error) => {

      resolve()
    })

  }


}
